import type { IconProps } from './types';

export const LinkIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M6.37234 10.138C6.66514 9.84526 7.13999 9.84539 7.43288 10.138C7.72575 10.4308 7.72569 10.9056 7.43288 11.1985L5.50417 13.1272C4.022 14.6095 4.02212 17.0131 5.50417 18.4954L5.64577 18.6302C7.13577 19.9765 9.43628 19.9314 10.8723 18.4954L12.801 16.5667L12.8577 16.5149C13.1522 16.2747 13.587 16.2923 13.8616 16.5667C14.1362 16.8412 14.1536 17.276 13.9134 17.5706L13.8616 17.6272L11.9329 19.5559C9.92955 21.5592 6.72071 21.6222 4.64187 19.7444L4.44362 19.5559C2.37578 17.4879 2.37567 14.1347 4.44362 12.0667L6.37234 10.138ZM14.0413 8.89871C14.3342 8.60582 14.8089 8.60582 15.1018 8.89871C15.3944 9.19163 15.3946 9.66646 15.1018 9.95926L9.95925 15.1018C9.66645 15.3946 9.19162 15.3945 8.8987 15.1018C8.60581 14.8089 8.60581 14.3342 8.8987 14.0413L14.0413 8.89871ZM12.2639 4.25614C14.3427 2.37776 17.5523 2.44029 19.5559 4.44364L19.7434 4.64188C21.5611 6.65373 21.5613 9.72387 19.7434 11.7356L19.5559 11.9329L17.6272 13.8616C17.3343 14.1545 16.8596 14.1545 16.5667 13.8616C16.2739 13.5687 16.2738 13.0939 16.5667 12.8011L18.4954 10.8723L18.6301 10.7307C19.9328 9.28877 19.933 7.08767 18.6301 5.64579L18.4954 5.50418C17.0592 4.06826 14.7588 4.02396 13.2688 5.37039L13.1272 5.50418L11.1985 7.43289C10.9056 7.72578 10.4309 7.72578 10.138 7.43289C9.84528 7.13999 9.84514 6.66517 10.138 6.37235L12.0667 4.44364L12.2639 4.25614Z"
        fill={color}
      />
    </svg>
  );
};
